import React from 'react';

import { RENTAL_PATH } from 'constants/routes';

import {
  Product,
  ProductBody,
  ProductList,
  ProductThumb,
  ProductHeader,
  IconDiv
} from '../styles';
import { Icon } from 'components/shared';
import thumb from './thumb.jpeg';
import { HomePageButtonNew } from 'components/temoraryHomePage';

function RentalLoans() {
  const advantages = [
    '5/1 & 30-Year Fixed-Rates',
    'Up to 80% LTV Purchases & Refinances',
    'Up to 75% LTV Cash-Outs',
    'Refinances, Cash-Out & Purchases',
  ];

  return (
    <Product color="rental" to={RENTAL_PATH}>
      <div>
        <div>
          <ProductHeader>
            <IconDiv>
              <Icon icon='home' />
            </IconDiv>
            Rental Loans
          </ProductHeader>
          <ProductThumb src={thumb} />
        </div>
        <ProductBody>
          <ProductList>{advantages}</ProductList>
        </ProductBody>
      </div>
      <HomePageButtonNew>Apply now</HomePageButtonNew>
    </Product>
  );
}

export default RentalLoans;
